module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/step4-pict01-819355610910a49bd5a7259bb559a949.jpg";